var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainersLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.5V18.5H7V13.5H2ZM1 11.5C0.447715 11.5 0 11.9477 0 12.5V19.5C0 20.0523 0.447715 20.5 1 20.5H8C8.55229 20.5 9 20.0523 9 19.5V12.5C9 11.9477 8.55229 11.5 8 11.5H1Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.5V7.5H18V2.5H13ZM12 0.5C11.4477 0.5 11 0.947715 11 1.5V8.5C11 9.05229 11.4477 9.5 12 9.5H19C19.5523 9.5 20 9.05229 20 8.5V1.5C20 0.947715 19.5523 0.5 19 0.5H12Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.5V18.5H18V13.5H13ZM12 11.5C11.4477 11.5 11 11.9477 11 12.5V19.5C11 20.0523 11.4477 20.5 12 20.5H19C19.5523 20.5 20 20.0523 20 19.5V12.5C20 11.9477 19.5523 11.5 19 11.5H12Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainersLogo);
export default __webpack_public_path__ + "static/media/containers-logo.71d702f74580d45d4381992c13ba81d5.svg";
export { ForwardRef as ReactComponent };